import axios from 'axios';

import { setLocal, getLocal } from '@/util/help.js';

// 创建 Axios 实例
const instance = axios.create({
  // withCredentials: true, // 跨源允许携带 Cookie
  timeout: 300000,
});

// 设置请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 在请求头中添加自定义的字段或进行其他操作
    config.headers['Custom-Field'] = 'Custom Value';
    const csrfToken = getLocal("csrfToken")
    if (csrfToken != "") {
      config.headers['x-csrf-token'] = csrfToken
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 设置响应拦截器
instance.interceptors.response.use(
  (response) => {
    // 处理响应数据或进行其他操作
    setLocal("csrfToken", response.headers['x-csrf-token'])
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;